import { getInspirationGalleryDetails, getInspirationGalleryImageById, getInspirationGalleryList, postCreateInspirationGallery } from "../../service/inspiration-gallery-service"

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getInspirationCategory } from '../../service/category-service';





// Initial state definition
const initialState = {
    inspirationGalleryList: [],
    inspirationGalleryImageList: [],
    inspirationGalleryDetails: null,
    isLoading: false,
    isListNext: false,
    isImageNext: false,
    error: ""
};

// Async thunk to fetch candidates
export const getInspirationGalleryData = createAsyncThunk(
    'inspirationGallerySlice/list',
    async (payload) => {

        const response = await getInspirationGalleryList(payload);
        return response.data;
    }
);

export const getInspirationGalleryById = createAsyncThunk(
    'inspirationGallerySlice/details',
    async (id) => {

        const response = await getInspirationGalleryDetails(id);
        return response.data;
    }
);

export const getInspirationGalleryImageByIdData = createAsyncThunk(
    'inspirationGallerySlice/imageDetails',
    async (payload) => {


        const response = await getInspirationGalleryImageById(payload);

        return response.data;
    }
);

export const createInspirationGallery = async (activeTab, id, payload) => {
    return await postCreateInspirationGallery(activeTab, id, payload)
}


// Slice definition
export const inspirationGallerySlice = createSlice({
    name: 'inspirationGallerySlice',
    initialState,
    reducers: {
        clearImageList: (state) => {
            state.inspirationGalleryImageList = []
        },
        clearGalleryList: (state) => {
            state.inspirationGalleryList = []
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInspirationGalleryData.pending, (state, action) => {
                const skip = action.meta.arg?.skip ?? 0;
                if (skip === 0) {
                    state.isLoading = true;
                }
            })

            .addCase(getInspirationGalleryData.fulfilled, (state, action) => {
                const { result, skip } = action.payload;

                // If skip === 0, replace list (new search/filter)
                if (skip === 0) {
                    state.inspirationGalleryList = result;
                } else {
                    // Otherwise, append for infinite scroll
                    state.inspirationGalleryList = [...state.inspirationGalleryList, ...result];
                }

                // Check if more data exists
                state.isListNext = action.payload.isNext;
                state.isLoading = false;
                state.error = "";
            })
            .addCase(getInspirationGalleryData.rejected, (state, action) => {
                state.inspirationGalleryList = [];
                state.isLoading = false;
                state.error = action.payload.error;
            })
            .addCase(getInspirationGalleryById.pending, (state) => {
                state.isLoading = true;
            })

            .addCase(getInspirationGalleryById.fulfilled, (state, action) => {
                const { data } = action.payload
                state.inspirationGalleryDetails = data
                state.isLoading = false
                state.error = ""
            })
            .addCase(getInspirationGalleryById.rejected, (state, action) => {
                state.inspirationGalleryDetails = null;
                state.isLoading = false;
                state.error = action.payload.error;
            })

            .addCase(getInspirationGalleryImageByIdData.pending, (state, action) => {
                const skip = action.meta.arg?.skip ?? 0;
                if (skip === 0) {
                    state.isLoading = true;
                }
            })

            .addCase(getInspirationGalleryImageByIdData.fulfilled, (state, action) => {
                const { result = [] } = action?.payload || []

                state.inspirationGalleryImageList = [...state.inspirationGalleryImageList, ...result]
                state.isImageNext = action.payload.isNext
                state.isLoading = false
                state.error = ""
            })
            .addCase(getInspirationGalleryImageByIdData.rejected, (state, action) => {
                state.inspirationGalleryImageList = [];
                state.isLoading = false;
                state.error = action.payload.error;
            })


    },
});

export default inspirationGallerySlice.reducer;

// Export actions (if any)
export const {
    clearImageList,
    clearGalleryList
} = inspirationGallerySlice.actions;
